import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';
import { LicenseUsersService } from '@portal-core/license-users/services/license-users.service';
import { LicenseUsersPageFilterConfig } from '@portal-core/license-users/util/license-users-page-filter-config';
import { ProjectsService } from '@portal-core/projects/services/projects.service';
import { ListControl } from '@portal-core/ui/list/util/list-control';
import { ListBase } from '@portal-core/ui/list/util/list.base';
import { of } from 'rxjs';

@Component({
  selector: 'mc-project-license-users-list',
  templateUrl: './project-license-users-list.component.html',
  styleUrls: ['./project-license-users-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectLicenseUsersListComponent extends ListBase<LicenseUser> implements OnChanges {
  @Input() projectId: number;
  @Input() canEdit: boolean = false;

  @Output() saved: EventEmitter<void> = new EventEmitter<void>();

  removing: number[] = [];

  filterConfig: LicenseUsersPageFilterConfig = new LicenseUsersPageFilterConfig([
    'User.FullName',
    'SeatType',
    'User.Email'
  ]);

  listControl: ListControl<LicenseUser> = new ListControl<LicenseUser>(this.licenseUsersService, filter => {
    if (typeof this.projectId === 'number') {
      return this.projectsService.getProjectLicenseUsersPage$(this.projectId, filter);
    } else {
      return of(null);
    }
  });

  constructor(
    private licenseUsersService: LicenseUsersService,
    private projectsService: ProjectsService,
    private snackBar: MatSnackBar,
  ) {
    super(licenseUsersService);
    const fullNameColumn = this.filterConfig.getColumn('User.FullName');
    fullNameColumn.filterEnabled = false;
    fullNameColumn.sortEnabled = true;
    const emailColumn = this.filterConfig.getColumn('User.Email');
    emailColumn.filterEnabled = false;
    emailColumn.sortEnabled = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.projectId) {
      this.hardReload();
    }
  }

  onRemoveLicenseUser(licenseUser: LicenseUser) {
    this.removing = [
      ...this.removing,
      licenseUser.Id
    ];
    this.projectsService.deleteProjectLicenseUser$(this.projectId, licenseUser.Id).subscribe(() => {
      this.licenseUsersService.removePagedDataListItems$(this.dataListId, [licenseUser.Id]);
      this.removing = this.removing.filter(id => id !== licenseUser.Id);
      this.saved.emit();
    }, error => {
      this.removing = this.removing.filter(id => id !== licenseUser.Id);
      this.snackBar.open('Unable to remove the user from the project.', 'OK');
    });
  }
}
